var map = {
	"./img1.png": 4887,
	"./img1@2x.png": 3081,
	"./img2.png": 4252,
	"./img2@2x.png": 4108,
	"./img3.png": 3669,
	"./img3@2x.png": 1839,
	"./img4.png": 9002,
	"./img4@2x.png": 6394,
	"./img5.png": 7859,
	"./img5@2x.png": 6013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8346;